// All attributes in customziable color must be consistency

export const CUSTOMIZABLE_COLOR_ATTRIBUTES = {
  background: 'background',
  title: 'title',
  header1: 'header1',
  header2: 'header2',
  subHeader: 'subHeader',
  subHeader2: 'subHeader2',
  text: 'text',
  button: 'button',
  caption: 'caption',
  tag: 'tag',
};

export const CUSTOMIZABLE_COLORS = {
  background: '--design-page-background-color',
  title: '--design-page-title-color',
  text: '--design-page-text-color',
  button: '--design-page-button-color',
  subHeader: '--design-page-sub-header-color',
  subHeader2: '--design-page-sub-header2-color',
  caption: '--design-page-caption-color',
  header1: '--design-page-header1-color',
  header2: '--design-page-header2-color',
  tag: '--design-page-tag-color',
};

export const CUSTOMIZABLE_COLOR_NAMES = {
  background: 'Background',
  title: 'Header',
  subHeader: 'Sub-Header 1',
  subHeader2: 'Sub-Header 2',
  text: 'Text',
  button: 'Button',
  caption: 'Caption',
  header1: 'Header 1',
  header2: 'Header 2',
  tag: 'Tag',
};

export const DEFAULT_COLORS = {
  [CUSTOMIZABLE_COLORS.background]: 'var(--white-color)',
  [CUSTOMIZABLE_COLORS.title]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.header1]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.header2]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.subHeader]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.subHeader2]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.text]: 'var(--primary-color)',
  [CUSTOMIZABLE_COLORS.button]: 'var(--gray-color)',
  [CUSTOMIZABLE_COLORS.caption]: '#585858',
  [CUSTOMIZABLE_COLORS.tag]: 'var(--primary-color)',
};

export const EXTEND_COLORS = {
  white: '#ffffff',
  black: '#000000',
  red: '#BD0E0E',
};

export const FOOTER_COLOR_VARIABLES = {
  text: '--footer-text-color',
  background: '--footer-bg-color',
};

export const HEADER_COLOR_VARIABLES = {
  text: '--header-text-color',
  background: '--header-bg-color',
};

export const HORIZONTAL_COLOR_VARIABLES = {
  text: '--horizontal-text-color',
  background: '--horizontal-bg-color',
};

export const SIDEBAR_COLOR_VARIABLES = {
  text: '--primary-color',
  background: '--sidebar-bg-color',
};
